(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 73700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(99500);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ PHONE_NUMBER; }
/* harmony export */ });
var PHONE_NUMBER = "phone_number";


/***/ }),

/***/ 96024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ authApiUrl; },
/* harmony export */   "u": function() { return /* binding */ errorCode; }
/* harmony export */ });
var authApiUrl = {
    SIGNUP: "/api/v1/user/local/signup",
    LOGIN: "/api/v1/user/login",
    LOGIN_BY_PASSWORD: "/api/v1/user/login/password",
    RESET_PASSWORD: "/api/v1/user/password/reset",
    CREATE_PASSWORD: "/api/v1/user/password/create",
    ACTIVATE: "/api/v1/user/activate",
    RESEND_OTP: "/api/v1/user/resend/otp"
};
var errorCode = {
    OTP_NOT_EXPIRE: "OTP_NOT_EXPIRE"
};


/***/ }),

/***/ 99500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95298);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(95496);
// EXTERNAL MODULE: ./components/index.ts + 87 modules
var components = __webpack_require__(83554);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./components/ui/SelectCountry/index.tsx
var SelectCountry = __webpack_require__(59210);
// EXTERNAL MODULE: ./features/auth/const.ts
var auth_const = __webpack_require__(57021);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var profile = __webpack_require__(48309);
;// CONCATENATED MODULE: ./features/auth/login/layout.tsx

















var LoginLayout = function(param) {
    var countries = param.countries;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var masterData = (0,profile/* useMasterData */.AE)();
    // CUSTOM THEME
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var ref2 = theme !== null && theme !== void 0 ? theme : {}, logo_url = ref2.logo_url, web_bg_login_left_url = ref2.web_bg_login_left_url, web_bg_login_right_url = ref2.web_bg_login_right_url;
    var t = (0,esm/* useTranslation */.$G)("auth").t;
    var ref3 = (0,react.useState)(countries.find(function(v) {
        return v.code === shared/* DefaultCountry.Vn */.Ud.Vn;
    }) || null), defaultCountry = ref3[0], setDefaultCountry = ref3[1];
    var ref4 = (0,react.useState)(false), isShow = ref4[0], setShow = ref4[1];
    var ref5 = useLoginQuery({
        onSuccess: function(param) {
            var data = param.data;
            var phone = data.phone, country = data.country;
            if (phone) {
                return router.replace({
                    pathname: shared/* PagePath.LoginConfirmPage */._.LoginConfirmPage,
                    query: {
                        phone: phone,
                        country: country
                    }
                });
            }
        },
        onError: function(error) {
            if (error.code === "OTP_NOT_EXPIRE") {
                var _data = error.data, phone = _data.phone, country = _data.country;
                return router.replace({
                    pathname: shared/* PagePath.LoginConfirmPage */._.LoginConfirmPage,
                    query: {
                        phone: phone,
                        country: country || shared/* DefaultCountry.Vn */.Ud.Vn
                    }
                });
            }
            react_hot_toast_esm/* default.error */.ZP.error(error.message);
        }
    }), mutate = ref5.mutate, isLoading = ref5.isLoading;
    var ref6 = (0,index_esm/* useForm */.cI)({
        defaultValues: FormLoginDefaultValue,
        resolver: (0,yup_module/* yupResolver */.X)(es/* object */.Ry({
            phone: es/* string */.Z_().required(t("login.message.phone-required"))
        }))
    }), control = ref6.control, watch = ref6.watch, setValue = ref6.setValue, handleSubmit = ref6.handleSubmit, errors = ref6.formState.errors;
    (0,react.useEffect)(function() {
        var phone = localStorage.getItem(auth_const/* PHONE_NUMBER */.U);
        if (phone) {
            setValue("phone", phone);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onSubmit = handleSubmit(function(data) {
        localStorage.setItem(auth_const/* PHONE_NUMBER */.U, data.phone);
        var payload = {
            phone: data.phone,
            country: (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.code) || shared/* DefaultCountry.Vn */.Ud.Vn
        };
        mutate(payload);
    });
    var keyPress = function(e) {
        if (e.keyCode === 13) {
            onSubmit();
        }
    };
    var selectCountry = function(country) {
        setShow(false);
        setDefaultCountry(country);
    };
    var onLoginByPassword = function() {
        var phone = watch("phone");
        if (phone) {
            localStorage.setItem(auth_const/* PHONE_NUMBER */.U, phone);
        }
        router.push(shared/* PagePath.LoginByPasswordPage */._.LoginByPasswordPage);
    };
    if (!masterData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: t("login.title"),
                description: t("login.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-h-screen tw-grid tw-grid-cols-1 lg:tw-grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "tw-hidden lg:tw-flex tw-justify-center tw-items-center tw-relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            src: web_bg_login_left_url !== null && web_bg_login_left_url !== void 0 ? web_bg_login_left_url : "/splash.png",
                            alt: "splash",
                            className: "tw-w-full tw-h-full",
                            rounded: "tw-rounded-none",
                            // objectFit='fill'
                            // Temporary update for them Tet
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "tw-grid tw-grid-cols-1 tw-justify-center tw-items-center tw-px-4",
                        style: {
                            backgroundImage: web_bg_login_right_url ? "url(".concat(web_bg_login_right_url, ")") : "unset",
                            backgroundSize: "cover"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-flex-col tw-w-full sm:tw-w-96 tw-mx-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "tw-text-center tw-text-2xl tw-font-semibold tw-text-primary-main",
                                    children: t("login.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-mt-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-flex tw-items-center tw-h-[50px] tw-border tw-rounded-full tw-border-primary-main tw-overflow-hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " tw-pl-4 tw-pr-2 tw-py-2 tw-flex tw-cursor-pointer tw-w-26",
                                                    onClick: function() {
                                                        return setShow(!isShow);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-flex-1 tw-flex tw-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                                    src: "https://flagcdn.com/w40/".concat(defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.code.toLocaleLowerCase(), ".png"),
                                                                    alt: (defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.code) || "country",
                                                                    className: "tw-w-5 tw-h-3 tw-overflow-hidden tw-mr-2",
                                                                    objectFit: "cover"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-text-sm",
                                                                    children: defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.phone
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                            className: "tw-text-primary-main tw-w-5 tw-h-5",
                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowDownIcon */.ve, {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                                    name: "phone",
                                                    control: control,
                                                    render: function(param) {
                                                        var field = param.field;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "tw-flex tw-flex-1 tw-px-2 focus:tw-outline-none",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                                className: "tw-full tw-flex-1 tw-h-10",
                                                                containerClassName: "tw-flex-1 !tw-border-b-0 tw-border-l tw-border-l-primary-main",
                                                                onKeyDown: keyPress,
                                                                placeholder: t("sign-up.form.label.phone")
                                                            }))
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        ((ref = errors.phone) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-text-red-500 tw-text-xs tw-mt-2 tw-px-4",
                                            children: (ref1 = errors.phone) === null || ref1 === void 0 ? void 0 : ref1.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-flex tw-flex-col tw-mt-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                                        loading: isLoading,
                                        onClick: onSubmit,
                                        className: "tw-h-[50px] tw-rounded-full tw-mt-2",
                                        children: t("login.btn.login-by-otp")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-mt-12 tw-text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: t("login.label.social-login")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-mt-3 tw-justify-center tw-space-x-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: onLoginByPassword,
                                                className: "tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-h-10 tw-w-10 tw-border tw-border-primary-main tw-rounded-full tw-flex tw-justify-center tw-items-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LockIcon */.mB, {
                                                            width: "24",
                                                            height: "24"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "tw-text-[10px] tw-text-primary-main",
                                                        children: t("login.label.password")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-mt-12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                            t: t,
                                            i18nKey: "login.label.sign-up",
                                            components: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                                    url: {
                                                        pathname: shared/* PagePath.SignUpPage */._.SignUpPage
                                                    }
                                                }, "sign-up"), 
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            isShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectCountry/* default */.Z, {
                options: countries,
                selectCountry: selectCountry,
                onClose: function() {
                    return setShow(false);
                }
            })
        ]
    });
};
/* harmony default export */ var layout = (LoginLayout);

;// CONCATENATED MODULE: ./features/auth/login/const.ts
var FormLoginDefaultValue = {
    phone: ""
};

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(88767);
// EXTERNAL MODULE: ./libs/axios/index.ts
var axios = __webpack_require__(80787);
// EXTERNAL MODULE: ./features/auth/index.ts
var auth = __webpack_require__(96024);
;// CONCATENATED MODULE: ./features/auth/login/api.ts



var useLoginQuery = function(options) {
    return (0,react_query_es.useMutation)(function(payload) {
        var phone = payload.phone, country = payload.country;
        return axios/* default.post */.ZP.post(auth/* authApiUrl.LOGIN */.I.LOGIN + "/".concat(phone, "?country=").concat(country), {});
    }, options);
};

;// CONCATENATED MODULE: ./features/auth/login/index.ts





;// CONCATENATED MODULE: ./pages/login/index.tsx



var LoginPage = function(param) {
    var countries = param.countries;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout, {
        countries: countries
    });
};
var __N_SSP = true;
/* harmony default export */ var login = (LoginPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(73700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);